import TestSearchBar from './TestSearch.vue'

TestSearchBar.install = function(Vue){
    Vue.component(TestSearchBar.name,TestSearchBar)
}

export default TestSearchBar